<form class="p-0 w-full flex flex-col items-center" [formGroup]="loginGroup"  autocomplete="off" (ngSubmit)="saveBtn()" #loginGroupForm>
  <div class="w-full flex flex-col h-[65px]">
    <input type="text" id="email" formControlName="username"
      class="focus-visible:outline-none h-[50px] w-full px-4 py-3 text-base border border-[#D0D5DD] rounded-lg transition-all duration-300 focus:outline-0 focus:border-primary hover:border-primary"
      [placeholder]="'FORM.FIELDS.EMAIL.TITLE' | translate" autocomplete="off">
    @if (username.invalid && username.touched) {
      <div class="error-container mt-1" class="text-xs text-red-500">
        @if (username.hasError('required')) {
          <b>{{('FORM.FIELDS.EMAIL.TITLE' | translate) + ' ' +
          ('FORM.FIELDS.PATTERNS.REQUIRED' | translate)}}</b>
        }
        @if (username.hasError('username')) {
          <b>{{('FORM.FIELDS.PATTERNS.VALID' | translate) + ' ' +
          ('FORM.FIELDS.EMAIL.TITLE' | translate)}}.</b>
        }
        @if (username.hasError('formError')) {
          <b>{{f.controls['email'].errors.formError}}</b>
        }
      </div>
    }
  </div>

  <div class="w-full flex flex-col h-[65px]">
    <input type="password" id="password" formControlName="password" reverse="true"
      class="focus-visible:outline-none h-[50px] w-full px-4 py-3 text-base border border-[#D0D5DD] rounded-lg transition-all duration-300 focus:outline-0 focus:border-primary hover:border-primary"
      [placeholder]="'FORM.FIELDS.PASSWORD.TITLE' | translate" passwordToggle autocomplete="new-password">
    @if (password.invalid && password.touched) {
      <div class="error-container mt-1" class="text-xs text-red-500">
        @if (password.hasError('required')) {
          <b>{{('FORM.FIELDS.PASSWORD.TITLE' | translate) + ' ' +
          ('FORM.FIELDS.PATTERNS.REQUIRED' | translate)}}</b>
        }
        @if (password.hasError('formError')) {
          <b>{{f.controls['password'].errors.formError}}</b>
        }
      </div>
    }
  </div>

  <button pRipple
    class="mt-3 w-full h-[52px] py-2 px-4 flex items-center justify-center bg-primary text-white border border-primary rounded-md text-base font-medium transition-all duration-300 ease-in-out hover:bg-opacity-90-pct"
    [disabled]="_activeProgress || loginGroup.invalid" [class.opacity-40-pct]="_activeProgress || loginGroup.invalid">
    @if (!_activeProgress) {
      <span>{{'FORM.ACTIONS.LOGIN' | translate}}</span>
    }
    @if (_activeProgress) {
      <span class="text-white font-semibold text-xl pi pi-spin pi-spinner"></span>
    }
  </button>

  <div class="flex items-center justify-between gap-2 mt-5 w-full">
    <div class="remember_me_checkbox flex items-center gap-2">
      <p-checkbox binary="true" formControlName="remember_me" inputId="remember_me"></p-checkbox>
      <label for="remember_me" class="text-sm font-medium text-[#475467]">{{'FORM.FIELDS.REMEMBER_ME.TITLE' | translate}}</label>
    </div>

    <a
      pRipple
      href="#/reset"
      target="_self"
      class="text-primary text-sm font-medium underline"
    [ngClass]="{'unClickable disable': _activeProgress}">{{'FORM.ACTIONS.FORGOT_PASSWORD' | translate}}</a>
  </div>
</form>
